import tippy from 'tippy.js';

const shownNotices = new WeakSet();

export const initializeSheetNotices = root => {
    root.querySelectorAll('[data-sheet-notice]').forEach(notice => {
        if (shownNotices.has(notice)) {
            return;
        }

        shownNotices.add(notice);

        (notice._tippy ?? tippy(notice)).show();
    });
};
